module.exports = __webpack_public_path__ + "img/IMG_5907.e53bfb85.jpg";